import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { QuerifyService } from '../../services/querify.service';
import { Mutations } from './mutations';
import { Queries } from './queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./queries";
import * as i3 from "./mutations";
import * as i4 from "../../services/querify.service";
var MaintenancesApi = /** @class */ (function () {
    function MaintenancesApi(apollo, queries, mutations, querify) {
        this.apollo = apollo;
        this.queries = queries;
        this.mutations = mutations;
        this.querify = querify;
    }
    MaintenancesApi.prototype.searchOne = function (id) {
        return this.apollo
            .query({
            query: this.queries.getMaintenance(),
            variables: { id: id }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['maintenance'];
        }));
    };
    MaintenancesApi.prototype.search = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.getPaginatedMaintenances(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['maintenances'];
        }));
    };
    MaintenancesApi.prototype.searchWithWarranties = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.getPaginatedMaintenancesWithWarranties(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['maintenances'];
        }));
    };
    MaintenancesApi.prototype.save = function (maintenance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.mutate({
                        mutation: this.mutations.createMaintenance(),
                        variables: {
                            input: maintenance
                        }
                    }).toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['createMaintenance'];
                    })];
            });
        });
    };
    MaintenancesApi.prototype.update = function (id, maintenance) {
        return this.apollo.mutate({
            mutation: this.mutations.updateMaintenance(),
            variables: {
                id: id,
                input: maintenance
            }
        });
    };
    MaintenancesApi.prototype.reallocateMaintenance = function (id, reallocate) {
        return this.apollo.mutate({
            mutation: this.mutations.reallocateMaintenance(),
            variables: {
                id: id,
                input: reallocate
            }
        });
    };
    MaintenancesApi.prototype.cancelMaintenance = function (_a) {
        var id = _a.id, cancellationReason = _a.cancellationReason;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: this.mutations.cancelMaintenance(),
                            variables: {
                                id: id,
                                input: {
                                    cancellationReason: cancellationReason
                                }
                            }
                        }).toPromise()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MaintenancesApi.prototype.archiveMaintenance = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: this.mutations.archiveMaintenance(),
                            variables: {
                                id: id,
                            }
                        }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MaintenancesApi.prototype.unarchiveMaintenance = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: this.mutations.unarchiveMaintenance(),
                            variables: {
                                id: id,
                            }
                        }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MaintenancesApi.prototype.reopenMaintenance = function (_a) {
        var id = _a.id, reopeningReason = _a.reopeningReason, scheduleSuggestions = _a.scheduleSuggestions;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: this.mutations.reopenMaintenance(),
                            variables: {
                                id: id,
                                input: {
                                    reopeningReason: reopeningReason,
                                    scheduleSuggestions: scheduleSuggestions
                                }
                            }
                        }).toPromise()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MaintenancesApi.prototype.createMaintenanceComment = function (comment) {
        return this.apollo
            .mutate({
            mutation: this.mutations.createMaintenanceComment(),
            variables: {
                input: comment
            }
        })
            .toPromise()
            .then(function (_a) {
            var data = _a.data;
            return data['createMaintenanceComment'];
        });
    };
    MaintenancesApi.prototype.removeMaintenanceComment = function (commentId) {
        return this.apollo.mutate({
            mutation: this.mutations.removeMaintenanceComment(),
            variables: {
                id: commentId
            }
        });
    };
    MaintenancesApi.prototype.removeMaintenanceLabel = function (input) {
        return this.apollo.mutate({
            mutation: this.mutations.removeMaintenanceLabel(),
            variables: input
        });
    };
    MaintenancesApi.prototype.addMaintenanceLabel = function (input) {
        return this.apollo.mutate({
            mutation: this.mutations.addMaintenanceLabel(),
            variables: {
                input: input
            }
        });
    };
    MaintenancesApi.prototype.saveMaintenanceLabel = function (input, isRemove) {
        if (!isRemove) {
            return this.addMaintenanceLabel(input).toPromise();
        }
        return this.removeMaintenanceLabel(input).toPromise();
    };
    MaintenancesApi.prototype.searchMaintenanceComment = function (query) {
        return this.apollo
            .query({
            query: this.queries.getComments(),
            variables: query
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['maintenance']['comments'];
        }));
    };
    MaintenancesApi.prototype.searchMaintenanceQuotations = function (query) {
        return this.apollo
            .query({
            query: this.queries.getQuotations(),
            variables: query
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['maintenance']['quotations'];
        }));
    };
    MaintenancesApi.prototype.cancelMaintenanceScheduleSuggestions = function (maintenanceId) {
        return this.apollo.mutate({
            mutation: this.mutations.cancelMaintenanceScheduleSuggestions(),
            variables: {
                id: maintenanceId
            }
        });
    };
    MaintenancesApi.prototype.acceptMaintenanceScheduleSuggestions = function (maintenanceId) {
        return this.apollo.mutate({
            mutation: this.mutations.acceptMaintenanceScheduleSuggestions(),
            variables: {
                id: maintenanceId
            }
        });
    };
    MaintenancesApi.prototype.updateMaintenanceScheduleSuggestions = function (maintenanceId, suggestions) {
        return this.apollo.mutate({
            mutation: this.mutations.updateMaintenanceScheduleSuggestions(),
            variables: {
                id: maintenanceId,
                suggestions: suggestions
            }
        });
    };
    MaintenancesApi.prototype.searchMaintenanceProductsServices = function (variables) {
        return this.apollo
            .query({
            query: this.queries.getProductsServices(),
            variables: variables,
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['maintenance']['productsServices'];
        }));
    };
    MaintenancesApi.prototype.getMaintenancePendenciesTotalCount = function (id) {
        return this.apollo
            .query({
            query: this.queries.getPendenciesTotalCount(),
            variables: { id: id }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['maintenance']['pendencies']['totalCount'];
        }));
    };
    MaintenancesApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MaintenancesApi_Factory() { return new MaintenancesApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries), i0.ɵɵinject(i3.Mutations), i0.ɵɵinject(i4.QuerifyService)); }, token: MaintenancesApi, providedIn: "root" });
    return MaintenancesApi;
}());
export { MaintenancesApi };
